import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import "./index.css"

import { AppProvider } from './context';
import TownPlanningDashboard from './pages/TownPlanningDashboard';
import DocumentList from './pages/DocumentList';
import PDFViewer from './components/PDFViewer'; // Import the new component
import ConversionCalculator from './pages/ConversionCalculator';
import DevelopmentChargesCalculator from './pages/DevelopmentChargesCalculator';
import AncillaryFSICalculator from './pages/AncillaryFSICalculator';
import PremiumFSICalculator from './pages/PremiumFSICalculator';
import UlcPremium from './pages/UlcPremium';
import BuiltUpAreaCalculator from './pages/BuiltUpAreaCalculator';
import Disclaimer from './pages/Disclaimer';
import AboutUs from './pages/AboutUs';
import Feedback from "./pages/Feedback";
import Objectives from "./pages/Objectives";

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<TownPlanningDashboard />} />
          <Route path="/documents" element={<DocumentList />} />
          <Route path="/pdf-viewer" element={<PDFViewer />} /> {/* Add this route */}
          <Route path="/area-convertor" element={<ConversionCalculator />} />
          <Route path="/development-charges" element={<DevelopmentChargesCalculator />} />
          <Route path="/ancillary-fsi" element={<AncillaryFSICalculator />} />
          <Route path="/premium-fsi" element={<PremiumFSICalculator />} />
          <Route path="/ulc-premium" element={<UlcPremium />} />
          <Route path="/built-up-area-calculator" element={<BuiltUpAreaCalculator />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/objectives" element={<Objectives />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;